import { extractSegmentData } from '../../utils/utils';
import CabinUpgradeUnavailableSegmentCard from './CabinUpgradeUnavailableSegmentCard';
import CabinUpgradeAvailableSegmentCard from './CabinUpgradeAvailableSegmentCard';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const CabinUpgradeSelection = ({
  availabilityTexts,
  segmentUpgradeList,
  setUnselectedCabinUpgrades,
  selectedCabinUpgradeOptions,
  unselectedCabinUpgrades,
  setSelectedCabinUpgradeOptions
}) => {
  if (!(segmentUpgradeList !== null && segmentUpgradeList !== void 0 && segmentUpgradeList.length)) {
    return null;
  }
  const {
    availabilityCardAvailabilityTitle,
    availabilityCardAvailableStatus,
    availabilityCardStatusTooltip,
    availabilityCardUnavailableStatus,
    drawerCheckboxSelectionLabel,
    drawerAdditionalContentText,
    drawerCardFlightDuration,
    drawerCardSelectionTitle,
    drawerSaveButtonLabel,
    drawerTitle,
    drawerTotalPriceLabel,
    drawerPerPersonLabel,
    drawerPerksPremiumEconomyUpgradeType,
    drawerPerksPremiumEconomyAvailablePerks,
    drawerPerksBusinessUpgradeType,
    drawerPerksBusinessAvailablePerks,
    drawerPerksFirstClassUpgradeType,
    drawerPerksFirstClassAvailablePerks,
    destinationLabel
  } = availabilityTexts;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: segmentUpgradeList.map(segmentUpgrade => {
      const segmentKey = `bound-${segmentUpgrade.boundIndex}-segment-${segmentUpgrade.segmentIndex}`;
      const {
        isSegmentAvailable,
        originDestinationAirportAriaLabelText,
        flightRoute
      } = extractSegmentData(segmentUpgrade, {
        availabilityCard: {
          availableStatus: availabilityCardAvailableStatus,
          unavailableStatus: availabilityCardUnavailableStatus
        },
        destinationLabel
      });
      return isSegmentAvailable ? /*#__PURE__*/_jsx(CabinUpgradeAvailableSegmentCard, {
        drawerTexts: {
          drawerCheckboxSelectionLabel,
          drawerAdditionalContentText,
          drawerCardFlightDuration,
          drawerCardSelectionTitle,
          drawerSaveButtonLabel,
          drawerTitle,
          drawerTotalPriceLabel,
          drawerPerPersonLabel,
          drawerPerksPremiumEconomyUpgradeType,
          drawerPerksPremiumEconomyAvailablePerks,
          drawerPerksBusinessUpgradeType,
          drawerPerksBusinessAvailablePerks,
          drawerPerksFirstClassUpgradeType,
          drawerPerksFirstClassAvailablePerks
        },
        flightRoute: flightRoute,
        originDestinationAirportAriaLabelText: originDestinationAirportAriaLabelText,
        segmentKey: segmentKey,
        segmentUpgrade: segmentUpgrade,
        selectedCabinUpgradeOptions: selectedCabinUpgradeOptions,
        setSelectedCabinUpgradeOptions: setSelectedCabinUpgradeOptions,
        setUnselectedCabinUpgrades: setUnselectedCabinUpgrades,
        unselectedCabinUpgrades: unselectedCabinUpgrades
      }, segmentKey) : /*#__PURE__*/_jsx(CabinUpgradeUnavailableSegmentCard, {
        availabilityCardTexts: {
          availabilityCardAvailabilityTitle,
          availabilityCardAvailableStatus,
          availabilityCardStatusTooltip,
          availabilityCardUnavailableStatus
        },
        flightRoute: flightRoute,
        originDestinationAirportAriaLabelText: originDestinationAirportAriaLabelText,
        segmentKey: segmentKey
      }, segmentKey);
    })
  });
};
export default CabinUpgradeSelection;
//# sourceMappingURL=CabinUpgradeSelection.js.map